export const countriesData = [
  {
    id: 1,
    name: "United States",
    amount: "2,750.00",
    flag: "/images/flags/usa.png",
  },
  {
    id: 2,
    name: "United Kingdom",
    amount: "1,350.00",
    flag: "/images/flags/great-britain.png",
  },
  {
    id: 3,
    name: "Isreal",
    amount: "2,450.00",
    flag: "/images/flags/isreal.png",
  },
  {
    id: 4,
    name: "Germany",
    amount: "2,050.00",
    flag: "/images/flags/germany.png",
  },
  {
    id: 5,
    name: "Argentina",
    amount: "2,750.00",
    flag: "/images/flags/argentina.png",
  },
];
